import { StaticImage } from "gatsby-plugin-image"

import { ALink } from "@trueskin-web/components"
import { crossCircleIcon } from "@trueskin-web/theme/icons/crossCircleIcon"

import advancedV1ImageSrc from "./images/advanced_v1.webp"
import advancedV2ImageSrc from "./images/advanced_v2.webp"
import cancelIcon from "./images/cancel.svg"
import completeImageSrc from "./images/complete.webp"
import einmalkaufV1ImageSrc from "./images/einmalkauf_v1.webp"
import einmalkaufV2ImageSrc from "./images/einmalkauf_v2.webp"
import essentialImageSrc from "./images/essential.webp"
import eventIcon from "./images/event.svg"
import howItWorksIcon from "./images/how-it-works.svg"
import moneyBackIcon from "./images/money-back.svg"
import refillIcon from "./images/refill.svg"
import rezeptImageSrc from "./images/rezept.webp"
import spaIcon from "./images/spa.svg"

const plans = {
  preset_formel_only_bimonthly_xl_AG_356_exp_V1_AG_633_extended_sub_tiers_exp: {
    title: "Essential",
    image: essentialImageSrc,
    details: [
      {
        content: "2-Monats-Vorrat Deiner exklusiv personalisierten Formel",
        icon: spaIcon,
        theme: "text",
      },
      {
        content: "Bequeme Lieferung alle 2 Monate",
        icon: refillIcon,
        theme: "text",
      },
      {
        content: "Keine Verpflichtung – jederzeit kündigen oder pausieren",
        icon: eventIcon,
        theme: "text",
      },
    ],
    voucher: "-24%",
    footnote: "Ärztliche Betreuung inklusive",
  },
  preset_sub_bimonthly_xl_AG_356_exp_V1_AG_633_extended_sub_tiers_exp: {
    title: "Advanced",
    image: advancedV1ImageSrc,
    details: [
      {
        content:
          "2-Monats-Vorrat Deiner kompletten Skincare-Routine für beste Ergebnisse",
        icon: spaIcon,
        theme: "text",
      },
      {
        content: "Bequeme Lieferung alle 2 Monate",
        icon: refillIcon,
        theme: "text",
      },
      {
        content: "Keine Verpflichtung – jederzeit kündigen oder pausieren",
        icon: eventIcon,
        theme: "text",
      },
    ],
    voucher: "-40%",
    footnote: "Ärztliche Betreuung inklusive",
  },
  preset_sub_bimonthly_xl_w_spf_AG_356_exp_V1_AG_633_extended_sub_tiers_exp: {
    title: "Complete",
    image: completeImageSrc,
    details: [
      {
        content:
          "2-Monats-Vorrat Deiner Skincare-Routine plus Sonnenschutz LSF 50 ",
        icon: spaIcon,
        theme: "text",
      },
      {
        content: "Bequeme Lieferung alle 2 Monate",
        icon: refillIcon,
        theme: "text",
      },
      {
        content: "Keine Verpflichtung – jederzeit kündigen oder pausieren",
        icon: eventIcon,
        theme: "text",
      },
    ],
    voucher: "-40%",
    footnote: "Ärztliche Betreuung und LSF 50 inklusive",
  },
  preset_single_purchase: {
    title: "Einmalkauf",
    description: "Keine fortlaufende ärztliche Betreuung",
    image: einmalkaufV1ImageSrc,
    details: [
      {
        content: "Erhalte einmalig ein FORMEL SKIN-Set als 1-Monats-Vorrat",
        icon: spaIcon,
        theme: "text",
      },
      {
        content:
          "50% weniger Produkt als bei unseren Angeboten mit fortlaufender Behandlung",
        icon: crossCircleIcon,
        theme: "#FF475D",
      },
      {
        content:
          "Keine fortlaufende ärztliche Betreuung & keine Anpassungen Deiner Formel",
        icon: crossCircleIcon,
        theme: "#FF475D",
      },
    ],
  },
  preset_prescription: {
    title: "Rezept",
    description: "+ ca. 35€ Apothekengebühren",
    image: rezeptImageSrc,
    details: [
      {
        content:
          "Erhalte ein Privatrezept, keine Zulieferung vom FORMEL SKIN-Set",
        icon: spaIcon,
        theme: "text",
      },
      {
        content:
          "Keine fortlaufende ärztliche Betreuung & keine Anpassungen Deiner Formel",
        icon: crossCircleIcon,
        theme: "#FF475D",
      },
      {
        content:
          "Ca. 35€ zusätzliche Herstellungskosten in der Apotheke und Wartezeit",
        icon: crossCircleIcon,
        theme: "#FF475D",
      },
    ],
  },
}

const products = [
  {
    title: "Personalisierte Formel",
    description:
      "Creme oder Gel mit aktiven Wirkstoffen, von Ärzt:innen personalisiert",
    image: ({ className }) => (
      <StaticImage
        src="../../../images/rebranded/two-month-package/2m-package-slider_slide3.png"
        alt=""
        height={56}
        objectFit="contain"
        className={className}
      />
    ),
    details: {
      title: "Deine Formel",
      slides: [
        ({ className }) => (
          <StaticImage
            src="../../../images/rebranded/rebranded-formula-01.png"
            alt=""
            objectFit="contain"
            objectPosition="center center"
            className={className}
          />
        ),
        ({ className }) => (
          <StaticImage
            src="../../../images/rebranded/rebranded-formula-ingredient.png"
            alt=""
            objectFit="cover"
            objectPosition="center center"
            className={className}
          />
        ),
      ],
      primaryColor: "primary",
      secondaryColor: "lightGreen",
      callout: {
        title: "Für sichtbar bessere Haut",
        description:
          "<p>Deine Formel wird extra von unserem Ärzt:innen-Team für Dich zusammengestellt. Alle Inhaltsstoffe und deren Dosierung sind so gewählt, dass sie Deine Haut schnellstmöglich verbessern.</p> <p>Die finale Zusammensetzung teilen wir Dir mit, nachdem Dein:e FORMEL SKIN Ärzt:in Deine Fotos ausgewertet und Deine Hautanalyse abgeschlossen hat.</p>",
        textColor: "background",
      },
      sections: [
        {
          title: "Unsere effektivsten Wirkstoffe:",
          description:
            "Diese Wirkstoffe könnte Deine Formel enthalten. Die finale Zusammensetzung bestimmen unsere Ärzt:innen.",
        },
      ],
      ingredients: [
        {
          title: "Tretinoin",
          image: ({ className }) => (
            <StaticImage
              src="./images/tretinoin.webp"
              alt=""
              className={className}
            />
          ),
          lines: [
            "Beschleunigt die Zellerneuerung",
            "Wirkt komedolytisch (Mitesser auflösend)",
          ],
        },
        {
          title: "Niacinamide",
          image: ({ className }) => (
            <StaticImage
              src="./images/niacinamide.webp"
              alt=""
              className={className}
            />
          ),
          lines: [
            "Ist eine Form von Vitamin B",
            "Stärkt die Hautbarriere",
            "Verfeinert das Hautbild",
          ],
        },
        {
          title: "Benzoylperoxid",
          image: ({ className }) => (
            <StaticImage
              src="./images/benzoylperoxid.webp"
              alt=""
              className={className}
            />
          ),
          lines: [
            "Wirkt antibakteriell",
            "Wirkt komedolytisch (Mitesser auflösend)",
          ],
        },
        {
          title: "Azelainsäure",
          image: ({ className }) => (
            <StaticImage
              src="./images/azelainsaure.webp"
              alt=""
              className={className}
            />
          ),
          lines: [
            "Wirkt entzündungshemmend",
            "Reduziert Pigmentflecken und Pickelmale",
          ],
        },
        {
          title: "Clindamycin",
          image: ({ className }) => (
            <StaticImage
              src="./images/clindamycin.webp"
              alt=""
              className={className}
            />
          ),
          lines: [
            "Ist ein topisches Antibiotikum",
            "Hemmt akneauslösende Bakterien",
          ],
        },
        {
          title: "Erythromycin",
          image: ({ className }) => (
            <StaticImage
              src="./images/erythromycin.webp"
              alt=""
              className={className}
            />
          ),
          lines: [
            "Wirkt anti-bakteriell und anti-entzündlich",
            "Wird u. a. bei perioraler Dermatitis eingesetzt",
          ],
        },
      ],
    },
  },
  {
    title: "Die Reinigung",
    description: "Befreit Deine Haut sanft von Talg, Schmutz und Make-up",
    image: ({ className }) => (
      <StaticImage
        src="../../../images/rebranded/two-month-package/2m-package-slider_slide5.png"
        alt=""
        height={56}
        objectFit="contain"
        className={className}
      />
    ),
    details: {
      title: "Deine Reinigung",
      slides: [
        ({ className }) => (
          <StaticImage
            src="../../../images/rebranded/rebranded-cleanser-01.png"
            alt=""
            objectFit="contain"
            objectPosition="center center"
            className={className}
          />
        ),
        ({ className }) => (
          <StaticImage
            src="../../../images/rebranded/rebranded-cleanser-ingredient.png"
            alt=""
            objectFit="cover"
            objectPosition="center center"
            className={className}
          />
        ),
      ],
      primaryColor: "blue",
      secondaryColor: "lightBlue",
      callout: {
        title: "Als perfekte Vorbereitung",
        description:
          "Das FORMEL SKIN-Reinigungsgel bereitet Deine Haut optimal auf die Wirkstoffe Deiner Formel vor. ",
        textColor: "text",
      },
      sections: [
        {
          title: "Das Reinigungsgel",
          description:
            "<p>Das Reinigungsgel befreit Deine Haut gründlich von überschüssigem Talg, Schmutz und Make-up, ohne sie auszutrocknen. </p> <p>Die entzündungshemmende Kombination aus Salicylsäure und Panthenol reguliert die Talgproduktion und reduziert Mitesser sichtbar. Gleichzeitig verfeinert Salicylsäure das Hautbild, minimiert Poren und wirkt gegen Unreinheiten, sodass Dein Teint ebenmäßiger und strahlender erscheint. Panthenol und Aloe Vera beruhigen Deine Haut, spenden intensiv Feuchtigkeit und unterstützen die natürliche Hautbarriere – für ein frisches und ausgeglichenes Hautgefühl.</p>",
        },
      ],
    },
  },
  {
    title: "Die Pflege",
    description: "Beruhigt Deine Haut und spendet nötige Feuchtigkeit",
    image: ({ className }) => (
      <StaticImage
        src="../../../images/rebranded/two-month-package/2m-package-slider_slide4.png"
        alt=""
        height={56}
        objectFit="contain"
        className={className}
      />
    ),
    details: {
      title: "Deine Pflege",
      slides: [
        ({ className }) => (
          <StaticImage
            src="../../../images/rebranded/rebranded-moisturizer-01.png"
            alt=""
            objectFit="contain"
            objectPosition="center center"
            className={className}
          />
        ),
        ({ className }) => (
          <StaticImage
            src="../../../images/rebranded/rebranded-moisturizer-02.png"
            alt=""
            objectFit="contain"
            objectPosition="center center"
            className={className}
          />
        ),
        ({ className }) => (
          <StaticImage
            src="../../../images/rebranded/rebranded-moisturizer-ingredient.png"
            alt=""
            objectFit="cover"
            objectPosition="center center"
            className={className}
          />
        ),
      ],
      primaryColor: "darkRose",
      secondaryColor: "hsla(344, 69%, 97%, 1)",
      callout: {
        title: "Für optimale Feuchtigkeit",
        description:
          "Je nach Hauttyp und medizinischer Behandlung wählen wir die passende Feuchtigkeitspflege für Dich aus. Sie wird Deine Haut hydratisiert halten und Deine tägliche Skincare-Routine abrunden. ",
        textColor: "text",
      },
      sections: [
        {
          title: "Die leichte Pflege",
          description:
            "Du wünschst Dir eine zarte Feuchtigkeitscreme, die Deine Haut hydratisiert und ein geschmeidiges Hautgefühl hinterlässt? Unsere leichte Pflege wurde speziell für fettige und zu Akne neigende Hauttypen entwickelt – aber auch normale und Mischhaut profitieren von dieser leichten Pflegecreme.",
        },
        {
          title: "Die reichhaltige Pflege",
          description:
            "Du wünscht Dir eine Pflege mit langanhaltender hydratisierender Wirkung? Die reichhaltige Pflege wurde speziell für trockene Haut entwickelt. Doch auch wenn Du von Natur aus keine trockene Haut hast, könnte sie Dir während Deiner Behandlung helfen. Denn sie kann den Begleiterscheinungen mancher Formel-Wirkstoffe (z. B. Trockenheit, Rötungen und Reizungen) vorbeugen oder entgegenwirken. ",
        },
      ],
    },
  },
  {
    title: "Der Sonnenschutz LSF 50",
    description: "Dein täglicher UVA- und UVB-Schutz",
    label: "Verbesserte Rezeptur",
    image: ({ className }) => (
      <StaticImage
        src="./images/spf-small.png"
        alt="SPF 50"
        height={42}
        objectFit="contain"
        className={className}
      />
    ),
    details: {
      title: "Der Sonnenschutz LSF 50",
      slides: [
        ({ className }) => (
          <StaticImage
            src="./images/spf-large.webp"
            alt="SPF 50"
            objectFit="contain"
            objectPosition="center center"
            className={className}
          />
        ),
        ({ className }) => (
          <StaticImage
            src="./images/spf-hands.webp"
            alt="SPF 50"
            objectFit="contain"
            objectPosition="center center"
            className={className}
          />
        ),
      ],
      primaryColor: "blue",
      secondaryColor: "lightBlue",
      callout: {
        title: "Für maximalen Schutz",
        description:
          "Einige unserer aktiven Wirkstoffe können das Verwenden von Sonnencreme erfordern – und als Haut-Expert:innen wissen wir: Wer seine Haut vor vorzeitiger Alterung schützen möchte, sollte ohnehin Sonnenschutz verwenden – und zwar täglich, auch im Winter.  <br /><br />Unsere leichte Sonnencreme ist für alle Hauttypen geeignet – ideal auch bei Akne und empfindlicher Haut.",
        textColor: "text",
      },
      sections: [
        {
          title: "Schütze Deine Haut jeden Tag ",
          description:
            "Unser leichter, pflegender Sonnenschutz mit Lichtschutzfaktor 50 bietet umfassenden Schutz vor UVA- und UVB-Strahlen: UVA-Strahlen, die vorzeitige Hautalterung verursachen, und UVB-Strahlen, die für Sonnenbrand verantwortlich sind. Die leichte, nährende Textur hydratisiert Deine Haut und sorgt für ein angenehmes Hautgefühl, ohne die Poren zu verstopfen. <br /><br />Ein innovativer Wirkstoffkomplex mit Eichenwurzelextrakt, Panthenol und Kiwi-Wasser stärkt die Hautbarriere und schützt vor freien Radikalen – ideal für die tägliche Anwendung.",
        },
      ],
    },
  },
]

const faq = [
  {
    question: "Wie funktioniert der Auto-Refill?",
    answer: (
      <>
        <p>
          Deine Haut durchläuft ständig Veränderungen. Daher erhältst Du bei
          unserem Auto-Refill alle 2 Monate ein neues FORMEL SKIN-Set. Zuvor
          hast Du die Möglichkeit, online einen Check-in durchzuführen, bei dem
          Deine Ärztin/Dein Arzt{" "}
          <span sx={{ fontWeight: "bold" }}>
            die Fortschritte Deiner Haut überprüft und Deine Formel bei Bedarf
            anpasst.
          </span>{" "}
          Außerdem kannst Du unser Ärzt:innen-Team jederzeit kontaktieren.
          Bequem und einfach per Chat.
        </p>
        <p>
          Dir passt der nächste Lieferzeitpunkt nicht? Kein Problem! In Deinem
          Account kannst Du Deine nächste Lieferung nach Deinen Wünschen
          anpassen oder pausieren.
        </p>
      </>
    ),
    icon: howItWorksIcon,
  },
  {
    question: "Wie funktioniert die Geld-zurück-Garantie?",
    answer: (
      <>
        <p>
          {" "}
          Sollte sich Deine <span sx={{ fontWeight: "bold" }}>Akne</span> nach 2
          bis 3 Monaten nicht verbessert haben, erstatten wir Deine
          Produktkosten.{" "}
        </p>{" "}
        <p>
          {" "}
          Für mehr Details klicke{" "}
          <ALink
            isTextColor
            isUnderlined
            href="https://support.formelskin.de/hc/de/articles/360022115719-Gibt-es-eine-Geld-zur%C3%BCck-Garantie-und-wie-funktioniert-sie-
"
            target="_blank"
            rel="noopener noreferrer"
          >
            hier.
          </ALink>
        </p>
      </>
    ),
    icon: moneyBackIcon,
  },
  {
    question: "Wann und wie kann ich meinen Auto-Refill kündigen?",
    answer: (
      <>
        <p>
          Du kannst Deinen Auto-Refill jederzeit ganz einfach online
          kündigen. Die Kündigung tritt dann zum Ende des aktuellen
          2-Monats-Rhythmus in Kraft.
        </p>
        <p>
          Natürlich ist dies unter Vorbehalt der medizinischen Eignung. Solltest
          Du Probleme mit der Behandlung haben, melde Dich bitte bei Deiner
          FORMEL SKIN-Ärztin bzw. -Arzt oder unserem Kundenservice, um eine
          Lösung zu finden.
        </p>
        <p>
          Solltest Du einen Deiner Lieferungszeitpunkte verschieben, verlängert
          oder verkürzt sich Deine Behandlungslaufzeit um die gewählte
          Anpassung.
        </p>
      </>
    ),
    icon: cancelIcon,
  },
]

const plansV1 = plans
const plansV2 = {
  ...plans,
  preset_sub_bimonthly_xl_AG_356_exp_V1_AG_633_extended_sub_tiers_exp: {
    ...plans.preset_sub_bimonthly_xl_AG_356_exp_V1_AG_633_extended_sub_tiers_exp,
    image: advancedV2ImageSrc,
  },
  preset_single_purchase: {
    ...plans.preset_single_purchase,
    image: einmalkaufV2ImageSrc,
    details: [
      {
        content: "Erhalte einmalig ein FORMEL SKIN-Set als 1-Monats-Vorrat",
        icon: spaIcon,
        theme: "text",
      },
      {
        content:
          "Nur halbe Produktmenge im Vergleich zu unseren Auto-Refill-Angeboten",
        icon: crossCircleIcon,
        theme: "#FF475D",
      },
      {
        content:
          "Keine fortlaufende ärztliche Betreuung & keine Anpassungen Deiner Formel",
        icon: crossCircleIcon,
        theme: "#FF475D",
      },
    ],
  },
}

export { plansV1, plansV2, products, faq }
